/**
 * Imports necessary dependencies and components for a React component.
 * @import React from "react" - The main React library.
 * @import { CSmartTable } from "@coreui/react-pro" - A custom table component from the CoreUI library.
 * @import { useTranslation } from "react-i18next" - A hook for internationalization.
 * @import Card from "react-bootstrap/Card" - A component from the React Bootstrap library for displaying a card.
 * @import CustomToggleButton from "../../components/customToggleButton/customToggleButton" - A custom toggle button component.
 * @import Breadcrumbs from "../../components/CustomeBreadcrumb/Breadcrumb" - A custom breadcrumb component.
 * @import ConfirmModal from "../../components/ConfirmModal
 */
import React from "react";
import { CSmartTable } from "@coreui/react-pro";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";

import EmptyCell from "../../components/emptyCell/emptyCell";
import ConfirmModal from "../../components/confirmModal/confirmModel";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import CustomLoadingHTML from "../../components/customLoadingHTML/customLoadingHTML";
import CustomToggleButton from "../../components/customToggleButton/customToggleButton";
import Constant from "../../util/constant";
import { Link } from "react-router-dom";

/**
 * A functional component that renders a notice type component.
 * @param {{object}} props - The props object containing various properties.
 * @param {{function}} props.showDeleteUserModal - The function to show the delete user modal.
 * @param {{function}} props.closeDeleteUserModal - The function to close the delete user modal.
 * @param {{function}} props.onDeleteUser - The function to delete a user.
 * @param {{function}} props.onProcced - The function to proceed with an action.
 * @param {{array}} props.columns - The array of columns for the table.
 * @param {{array}} props.NoticeItem - The array of notice items.
 * @param {{function}} props.onCheck
 */
const NoticeTypeComponent = (props) => {
  const { t } = useTranslation();

  /**
   * Destructures the properties object and assigns the corresponding values to variables.
   * @param {{object}} props - The properties object containing various values.
   * @returns None
   */
  const {
    showDeleteUserModal,
    closeDeleteUserModal,
    onDeleteUser,
    onProcced,
    columns,
    NoticeItem,
    onCheckSign,
    onCheckAction,
    openDeleteUserModal,
    clearSearchButton,
    noDataTitle,
    noDataDesc,
    showStatusModal,
    closeDeactiveModal,
    onHide,
    onUpdateNoticeType,
    placeHolderShimer,
    noDataFound,
    tableContainerRef,
    itemsPerPage,
    loading,
    tableFilterHeight,
    breadcrumbHeight,
    tabHeaderHeight,
    headerHeight,
    dimensions,
    smarttableref,
    loaderHtml,
    disableModelLoaderBotton,
    onTableFilterChange,
    searchValue,
    searchFilterClear,
    searchedData,
  } = props;
  console.log('searchedData?.length', searchedData?.length, NoticeItem?.length)
  return (
    <>
      {/**
       * Renders a React component that displays a page content for the NoticeType section.
       * The component includes a breadcrumb, a card, and a table.
       * @returns {React.Fragment} - The rendered React component.
       */}

      <React.Fragment>
        <div className="page-content NoticeType">
          <Breadcrumbs
            breadcrumbInner={false}
            breadcrumbMainTitle={true}
            breadcrumbItem={t("NOTICE_TYPE")}
          />
          <Card
            className={
              loading
                ? "Main_Card Main_NoticeType LoadingTable"
                : "Main_Card Main_NoticeType"
            }
          >
            <Card.Body className="p-0 activeTabSupplier">
              <div className="Main_Card_Body">
                <CSmartTable
                  cleaner
                  ref={smarttableref}
                  clickableRows
                  columns={columns}
                  columnFilter={false}
                  items={NoticeItem}
                  itemsPerPage={itemsPerPage}
                  scopedColumns={{
                    name: (item) => {
                      const limitedContent = item?.name?.slice(0, 200);
                      return (
                        <>
                          <td
                            className={
                              item?.noticetypestatus === Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p  className={`${
                                            limitedContent.length >= 20 && !limitedContent.includes(' ')
                                            ? 'breakeAll'
                                            : 'wordBrake'
                                          }`}>
                              {placeHolderShimer && (
                                <CustomeShimer />
                              )}
                              {limitedContent}
                            </p>
                          </td>
                        </>
                      );
                    },
                    signrequired: (item) => {
                      return (
                        <td
                          className={item?.noticetypestatus === Constant.GENERALKEYS.INACTIVE && "disableTd"}
                        >
                          <div className="SignrequiredWrapper">
                            {placeHolderShimer && (
                              <CustomeShimer />
                            )}
                            <CustomToggleButton
                              id={item?._id}
                              checked={item?.signrequired}
                              onCheckChange={(e) => {
                                onCheckSign(e, item);
                              }}
                            />
                            <p>{item?.signrequired ? "Yes" : "No"}</p>
                          </div>
                        </td>
                      );
                    },
                    noofnotice: (item) => {
                      const itemData = JSON.stringify(item);
                      return (
                        <td
                          className={item?.noticetypestatus === Constant.GENERALKEYS.INACTIVE && "disableTd"}
                        >
                          <div className="NoticeType-Wrapper">
                            {placeHolderShimer && (
                              <CustomeShimer />
                            )}
                              {/* <a href='/noticemanagement'></a> */}
                         <Link to={`/noticemanagement?itemData=${encodeURIComponent(itemData)}`}>
                            {item?.noofnotice}
                              <i className="dripicons-chevron-right"></i>
                             </Link>
                          </div>
                        </td>
                      );
                    },
                    noticetypestatus: (item) => {
                      return (
                        <td
                          className={item?.noticetypestatus === Constant.GENERALKEYS.INACTIVE && "disableTd"}
                        >
                          <div className="ActionWrapper">
                            {placeHolderShimer && (
                              <CustomeShimer />
                            )}
                            <CustomToggleButton
                              id=""
                              checked={item?.noticetypestatus === Constant.GENERALKEYS.ACTIVE ? true : false}
                              onCheckChange={(e) => {
                                onCheckAction(e, item);
                              }}
                            />
                            <button
                              className="Edit-Buttton"
                              onClick={(e) => {
                                onUpdateNoticeType(e, item);
                              }}
                            >
                              <i
                                className="mdi mdi-pencil-outline font-size-24"
                                id="deletetooltip"
                              ></i>
                            </button>
                            <button
                              className="Delete-Buttton"
                              onClick={(e) => {
                                openDeleteUserModal(e, item);
                              }}
                            >
                              <i
                                className="mdi mdi-Delete-outline font-size-24"
                                id="deletetooltip"
                              ></i>
                            </button>
                          </div>
                        </td>
                      );
                    },
                  }}
                  tableFilter
                  onTableFilterChange={onTableFilterChange}
                  tableFilterLabel={
                    searchValue?.length > 0 && (
                      <button
                        onClick={searchFilterClear}
                        className="btn-close"
                      ></button>
                    )
                  }
                  tableFilterPlaceholder={t("SEARCH_BY_NOTICE_TYPE")}
                  tableProps={{
                    className: NoticeItem?.length === 0 || searchedData?.length === 0 ? "NoticeTypeTable emptySearchTable" : "NoticeTypeTable",
                    responsive: true,
                    striped: false,
                    hover: false,
                  }}
                  noItemsLabel={
                    !placeHolderShimer &&
                    <EmptyCell
                      emptyItems={NoticeItem}
                      noDataTitle={
                        NoticeItem?.length === 0 ? noDataFound : noDataTitle
                      }
                      noDataAddButton={false}
                      noDataDesc={noDataDesc}
                      clearSearchButton={clearSearchButton}
                    />
                  }
                  tableBodyProps={{
                    className: "align-middle Table-Body-scroll",
                    style: {
                      height:
                        dimensions.height -
                        headerHeight -
                        breadcrumbHeight -
                        tableFilterHeight -
                        tabHeaderHeight -
                        (loading && loaderHtml) -
                        100,
                    },
                    ref: tableContainerRef,
                  }}
                />
                {loading && <CustomLoadingHTML />}
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>

      {/**
       * Renders a ConfirmModal component with the specified props.
       * @param {{string}} className - The class name for the ConfirmModal component.
       * @param {{boolean}} isModelIcon - Determines whether to display an icon in the ConfirmModal component.
       * @param {{function}} onHide - The function to be called when the ConfirmModal is hidden.
       * @param {{string}} iconColor - The color of the icon in the ConfirmModal component.
       * @param {{string}} iconCricle - The class name for the icon circle in the ConfirmModal component.
       * @param {{string}} modalTitle - The title of the ConfirmModal component.
       * @param {{string}} modalDescription - The description of the ConfirmModal component.
       * @
       */}
      {/* Disable Model Message Model */}
      <ConfirmModal
        className={"Deactivate"}
        isModelIcon={true}
        onHide={onHide}
        iconColor={"mdi mdi-toggle-switch-off-outline "}
        iconCricle={"iconCricleDelete"}
        modalTitle={t("DEACTIVATE")}
        modalDescription={t(
          "ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_NOTICE_TYPE"
        )}
        isUnderline={false}
        showModal={showStatusModal}
        leftBtnTitle={t("YES_DEACTIVATE")}
        isFirstButton={true}
        leftBtnClass={"Deactivate-btn"}
        onProcced={onProcced}
        rightBtnClass="Cancel_Btn"
        isSecondButton={true}
        rightBtnTitle={t("NO_CANCEL")}
        rightButtonClick={closeDeactiveModal}
        loaderButtonShow={disableModelLoaderBotton}
      />

      {/**
       * Renders a ConfirmModal component with the specified props.
       * @param {{string}} modalTitle - The title of the modal.
       * @param {{string}} modalDescription - The description of the modal.
       * @param {{boolean}} isUnderline - Determines if the modal title should be underlined.
       * @param {{boolean}} showModal - Determines if the modal should be shown.
       * @param {{string}} leftBtnTitle - The title of the left button.
       * @param {{boolean}} isModelIcon - Determines if an icon should be displayed in the modal.
       * @param {{string}} iconColor - The color of the icon.
       * @param {{string}} iconCricle - The class name of the icon circle.
       *
       */}
      {/* Delete Message Model */}
      <ConfirmModal
        modalTitle={t("DELETE")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_NOTICE_TYPE")}
        isUnderline={false}
        showModal={showDeleteUserModal}
        leftBtnTitle={t("YES_DELETE")}
        isModelIcon={true}
        iconColor={"mdi mdi-delete-outline "}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="Border_Button"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onDeleteUser}
        rightButtonClick={closeDeleteUserModal}
      />
    </>
  );
};

export default NoticeTypeComponent;
